var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSocialLinkedin = function SvgSocialLinkedin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30487 3.56397C6.30487 4.98926 5.28086 6.12972 3.63666 6.12972H3.60652C2.02344 6.12972 1 4.98926 1 3.56397C1 2.10854 2.05461 1 3.66774 1C5.28086 1 6.27426 2.10854 6.30487 3.56397ZM5.99431 8.15578V22.9996H1.27885V8.15578H5.99431ZM22.9998 22.9996L23 14.4886C23 9.92923 20.6737 7.80721 17.5707 7.80721C15.0671 7.80721 13.9462 9.24796 13.3204 10.2587V8.15617H8.60436C8.66651 9.54904 8.60436 23 8.60436 23H13.3204V14.71C13.3204 14.2664 13.351 13.8238 13.4757 13.5062C13.8165 12.6199 14.5924 11.7023 15.8952 11.7023C17.6022 11.7023 18.2845 13.0634 18.2845 15.0582V22.9996H22.9998Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSocialLinkedin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/social-linkedin.0d47e09d5632d2b345ddf1612e28b4f7.svg";